import { useEffect as e, useMemo as t, useState as n } from "/home/runner/work/oko-web/oko-web/node_modules/react/index.js";
//#region src/lib/hooks/useViewportSize.ts
var r = () => {
	let r = navigator.userAgent.toLowerCase(), i = /macintosh/i.test(r) && !!navigator.maxTouchPoints && navigator.maxTouchPoints > 1, a = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(r) || i, o = /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), s = /iPad|iPhone|iPod/.test(navigator.userAgent), c = /safari/i.test(navigator.userAgent) && !/chromium|edg|ucbrowser|chrome|crios|opr|opera|fxios|firefox/i.test(navigator.userAgent), l = /chromium|edg|ucbrowser|chrome|crios|opr|opera|fxios|firefox/i.test(navigator.userAgent), [u, d] = n(window.innerWidth), [f, p] = n(window.innerHeight), [m, h] = n(!1), [g, _] = n(!1), [v, y] = n(!1), [b, x] = n(!1), [S, C] = n(!1), [w, T] = n(!1), [E, D] = n(!1), [O, k] = n(!1), [A, j] = n(!1), [M, N] = n(!1);
	return e(() => {
		let e = () => {
			let e = window.innerWidth, t = window.innerHeight, n = e < 600 || t < 600, r = e < 840 || t < 840, i = t < e, s = t >= e;
			d(e), p(t), h(n), _(r), y(n && s), x(n && i), C(r && s), T(r && i), D(o && s), k(o && i), j(a && s), N(a && i);
		};
		return e(), window.addEventListener("resize", e), () => {
			window.removeEventListener("resize", e);
		};
	}, []), t(() => ({
		width: u,
		height: f,
		isMobile: m,
		isTablet: g,
		isTabletOrMobile: a || m,
		isMobilePortrait: v,
		isMobileLandscape: b,
		isTabletPortrait: S,
		isTabletLandscape: w,
		isTabletByUserAgent: a,
		isMobileByUserAgent: o,
		isDesktopByUserAgent: !(a || o),
		isMobilePortraitByUserAgent: E,
		isMobileLandscapeByUserAgent: O,
		isTabletPortraitByUserAgent: A,
		isTabletLandscapeByUserAgent: M,
		isIOSByUserAgent: s,
		isSafariByUserAgent: c,
		isChromiumBrowserByUserAgent: l,
		isIpad: i
	}), [
		u,
		f,
		m,
		g,
		v,
		b,
		S,
		w,
		a,
		o,
		E,
		O,
		A,
		M,
		i
	]);
};
//#endregion
export { r as useViewportSize };
